import React from "react";
import LegalPage from "@/components/LegalPage";

export default function Refund() {
  return (
    <LegalPage
      testid="refund-page"
      seoPath="/refund"
      title="Refund & Cancellation Policy"
      lastUpdated="May 2026"
      subtitle="Verdict is operated by Therefore Design. This Refund Policy describes how and when you can claim a refund for audit credits you have purchased."
      sections={[
        {
          heading: "1. Plain-English summary",
          body: `If something is wrong — duplicate charge, failed audit, technical issue, or you simply changed your mind within 7 days and haven't used the credits — write to info@thereforedesign.co.in and we'll make it right. We'd rather refund you than have you feel cheated.`,
        },
        {
          heading: "2. What's refundable",
          body: `(a) UNUSED CREDITS — within 7 days of purchase. If you buy a bundle and haven't run any audits against it, you can request a full refund within 7 days of the payment date. Refund is processed to the original payment method via Razorpay; bank-side credit usually takes 5-7 business days.

(b) FAILED AUDITS — automatically. If the LLM pipeline fails after a credit was debited (timeout, model error, internal bug), the credit is automatically refunded to your wallet — no email required.

(c) DUPLICATE OR ERRONEOUS CHARGES — anytime. If our system or Razorpay accidentally bills you twice for the same purchase, write in and we'll refund the duplicate immediately.

(d) BILLING DISPUTES — anytime within 60 days of the original charge.`,
        },
        {
          heading: "3. What's not refundable",
          body: `(a) CREDITS ALREADY USED. Once you've run an audit, the credit consumed for that audit is not refundable — you've received the service.

(b) DISSATISFACTION WITH AUDIT CONTENT. Audits are AI-generated outputs of a human-designed framework; they are advisory. If you disagree with a verdict that's a valid creative disagreement, but the credit is not refundable on this basis. If you believe the audit is technically broken (incoherent, contradictory, irrelevant to the artwork uploaded), please contact us and we'll investigate — failed audits get credit refunds (see clause 2.b).

(c) COMPLIMENTARY / FREE-TRIAL CREDITS. The free first-audit credit issued on sign-up has no cash value and is not refundable.

(d) AFTER 7 DAYS, UNUSED CREDITS DO NOT EXPIRE — but they also cannot be refunded for cash. They remain in your wallet indefinitely and can be used against any future audit.`,
        },
        {
          heading: "4. How to request a refund",
          body: `Write to info@thereforedesign.co.in (or use the form at /support) with:

• The email address tied to your Verdict account
• The Razorpay order ID or payment ID (visible in your Razorpay receipt email)
• The reason for the refund
• Whether you want refund to original payment method or credit reversal to wallet

We acknowledge within 24-48 working hours (Mon-Fri, 9 AM-5 PM IST) and process eligible refunds within 5 working days of acknowledgement. Bank settlement adds 5-7 business days on top.`,
        },
        {
          heading: "5. Cancellations",
          body: `There is no subscription on Verdict's current plans — every purchase is a one-time top-up. There is therefore nothing to cancel. You may stop using the Service at any time without notice; unused credits remain redeemable per clause 2(a) if within the 7-day window.

When subscription plans are introduced, this policy will be updated to describe cancellation, proration, and renewal.`,
        },
        {
          heading: "6. Disputes",
          body: `If we and you cannot agree on a refund through email, the dispute will be governed by the Terms of Service, including the governing-law and jurisdiction clauses (Mumbai, India).`,
        },
        {
          heading: "7. Contact",
          body: `Refund requests, questions, or appeals: info@thereforedesign.co.in. We typically respond same-day during working hours; always within 48 working hours.`,
        },
      ]}
    />
  );
}
